let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5Co4e")).then(() => parcelRequire('fRjRq'));